import {PUSH_NOTIFICATION_DATA} from "../../constants/ActionTypes";

const INIT_STATE = {
    pushNotifications: [],
    templates: []
};

const pushNotificationReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case PUSH_NOTIFICATION_DATA: {
            return {
                ...state,
                pushNotifications: action.payload,
            }
        }
        default:
            return state;
    }
}

export default pushNotificationReducer;
